<div class="container" id="job-details-page">
  <div class="content">
    <div class="template-main-content">
      <!-- Right Content Area -->
      <div class="template-details" id="job-details-content">

        <!-- Main Content -->
        <div class="template-content neo-scrollbar" id="job-details-main" *ngIf="!loadingSpinner && roleData">

          <!-- Basic Information Section -->
          <div class="section" id="job-details-basic-section">
            <div class="section-heading" id="job-details-basic-heading">
              Basic Information
            </div>
            <div class="section-content" id="job-details-basic-content">
              <div class="section-item no-border">
                @if (userPrivileges.has('job_role.update')) {
                <div class="section-item-content" [formGroup]="roleDetailsForm">

                  <!-- Role Name -->
                  <div class="neo-input-wrapper" id="job-details-name-wrapper">
                    <label for="role_name">Role Name <span class="required">*</span></label>
                    <input pInputText type="text" name="role_name" id="job-details-name-input"
                      formControlName="roleName"
                      [ngClass]="{'error': clicked && roleDetailsForm.controls['roleName'].errors}">
                    <app-handle-error [clicked]="clicked" [control]="roleDetailsForm.get('roleName')"
                      name="Role name"></app-handle-error>
                  </div>

                  <!-- Role Type and Work Mode Grid -->
                  <div class="neo-grid neo-grid-cols-2" id="job-details-type-mode-grid">
                    <div class="neo-input-wrapper" id="job-details-type-wrapper">
                      <label for="role_type">Role Type <span class="required">*</span></label>
                      <p-select bigger [options]="roleTypes" formControlName="roleType"
                        optionLabel="name" optionValue="id"
                        [filter]="true" [filterBy]="'name'"
                        [ngClass]="{'error': clicked && roleDetailsForm.controls['roleType'].errors}"
                        placeholder="Choose a role type" id="job-details-type-dropdown">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="roleDetailsForm.get('roleType')"
                        name="Role type"></app-handle-error>
                    </div>

                    <div class="neo-input-wrapper" id="job-details-mode-wrapper">
                      <label for="work_mode">Work Mode <span class="required">*</span></label>
                      <p-select bigger [options]="workModes" formControlName="workMode"
                        optionLabel="name" optionValue="value"
                        [ngClass]="{'error': clicked && roleDetailsForm.controls['workMode'].errors}"
                        placeholder="Choose work mode" id="job-details-mode-dropdown">
                      </p-select>
                      <app-handle-error [clicked]="clicked" [control]="roleDetailsForm.get('workMode')"
                        name="Work mode"></app-handle-error>
                    </div>
                  </div>

                </div>
                } @else {
                <div class="section-item-content">
                  <div class="neo-input-wrapper" id="job-details-name-wrapper">
                    <label>Role Name</label>
                    <span class="readonly-value">{{ roleData.name }}</span>
                  </div>
                  <div class="neo-grid neo-grid-cols-2" id="job-details-type-mode-grid">
                    <div class="neo-input-wrapper" id="job-details-type-wrapper">
                      <label>Role Type</label>
                      <span class="readonly-value">{{ roleData.role_type?.name }}</span>
                    </div>
                    <div class="neo-input-wrapper" id="job-details-mode-wrapper">
                      <label>Work Mode</label>
                      <span class="readonly-value">{{ roleData.work_mode }}</span>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>

          <!-- Job Details Section -->
          <div class="section" id="job-details-job-section">
            <div class="section-heading" id="job-details-job-heading">
              Job Details
            </div>
            <div class="section-content" id="job-details-job-content">

              <!-- Description -->
              <div class="section-item no-border" id="job-details-description-section">
                <div class="section-item-content" [formGroup]="roleDetailsForm">
                  <div class="neo-input-wrapper" id="job-details-description-wrapper">
                    <div class="description-header">
                      <label for="description">Role Description <span class="required">*</span></label>
                      @if (!editingDescription() && userPrivileges.has('job_role.update')) {
                      <span class="label-action" id="job-details-description-edit-btn"
                        (click)="editDescription()">Edit</span>
                      }
                      @if (editingDescription()) {
                      <span class="label-action" (click)="cancelEditDescription()">Close</span>
                      }
                    </div>
                    @if (!editingDescription()) {
                    <div class="description-display" id="job-details-description-display">
                      <app-innerhtml-view
                        [preview]="roleData.description ? (roleData.description | getSafeHTMLEmail) : 'No description available'"></app-innerhtml-view>
                    </div>
                    } @else {
                    <textarea id="job-details-description-editor" formControlName="roleDescription"
                      placeholder="Enter job description">
                      </textarea>
                    }
                  </div>
                </div>
              </div>

              <!-- Attachments Section -->
              <div class="section" id="job-details-attachments-section">
                <div class="section-heading" id="job-details-attachments-heading">
                  Attachments
                </div>
                <div class="section-content" id="job-details-attachments-content">
                  <div class="section-item no-border">
                    <div class="attachments-content">
                      <div *ngIf="attachmentName?.length" class="attached-file">
                        <div class="file-info">
                          <i class="pi pi-file-pdf file-icon"></i>
                          <div class="file-details">
                            <span class="file-name">{{ attachmentName }}</span>
                          </div>
                        </div>
                        <button *ngIf="userPrivileges.has('job_role.update')" type="button" class="remove-file-btn" (click)="onRemoveMedia(mediaFile[0])">
                          <i class="pi pi-trash"></i>
                        </button>
                      </div>

                      <div class="attachment-upload-box" ngx-dropzone [accept]="'image/JPEG, application/pdf'"
                        [multiple]="false" (change)="onSelectMedia($event)">
                        <ngx-dropzone-label *ngIf="!uploadingFile">
                          <div class="upload-content">
                            <div class="upload-icon">
                              <i class="pi pi-upload"></i>
                            </div>
                            <div class="upload-text">
                              <span class="upload-main">Drag & Drop your files here or <a href="javascript:void(0)"
                                  class="choose-link">Choose Files</a></span>
                              <span class="upload-hint">Recommended JPG, PDF Only (Max File Size : 2MB)</span>
                            </div>
                          </div>
                        </ngx-dropzone-label>
                        <ngx-dropzone-label *ngIf="uploadingFile">
                          <p-progressSpinner [style]="{width: '50px', height: '50px'}"
                            strokeWidth="4"></p-progressSpinner>
                        </ngx-dropzone-label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Location Details Section -->
          <div class="section" id="job-details-location-section">
            <div class="section-heading" id="job-details-location-heading">
              <span>Location Details</span>
              <div *ngIf="userPrivileges.has('job_role.update')">
                <button pButton label="Add Location" icon="pi pi-plus" class="p-button-text add-location-btn-small"
                  (click)="addLocationItem()" type="button">
                </button>
              </div>
            </div>
            <div class="section-content" id="job-details-location-content">

              <div class="section-item no-border" [formGroup]="roleDetailsForm">
                <div class="section-item-content">

                  <div formArrayName="locationInformation">
                    <div *ngFor="let location of locationInformation.controls; let i = index" [formGroupName]="i"
                      class="location-block">

                      <div class="location-header">
                        <span class="location-title">Location {{i + 1}}</span>
                        <button *ngIf="userPrivileges.has('job_role.update') && locationInformation.length > 1" pButton
                          icon="pi pi-trash" class="p-button-text p-button-sm p-button-danger"
                          (click)="removeLocationItem(i)" type="button">
                        </button>
                      </div>


                      <!-- Country, State, City Grid -->
                      <div class="neo-grid neo-grid-cols-3">
                        <div class="neo-input-wrapper">
                          <label>Country <span class="required">*</span></label>
                          <p-select bigger [options]="countries" formControlName="country" optionLabel="label"
                            optionValue="value" [filter]="true" [filterBy]="'label'"
                            [disabled]="!userPrivileges.has('job_role.update')" (onChange)="onCountryChange($event, i)"
                            placeholder="Select country">
                          </p-select>
                        </div>

                        <div class="neo-input-wrapper">
                          <label>State <span class="required">*</span></label>
                          <p-select bigger [options]="locationOptions[i]?.states || []" formControlName="state"
                            optionLabel="label" optionValue="value" [filter]="true" [filterBy]="'label'"
                            [disabled]="!userPrivileges.has('job_role.update')" (onChange)="onStateChange($event, i)"
                            placeholder="Select state">
                          </p-select>
                        </div>

                        <div class="neo-input-wrapper">
                          <label>City <span class="required">*</span></label>
                          <p-select bigger [options]="locationOptions[i]?.cities || []" formControlName="city"
                            optionLabel="label" optionValue="value" [disabled]="!userPrivileges.has('job_role.update')"
                            [filter]="true" placeholder="Select city">
                          </p-select>
                        </div>
                      </div>

                      <!-- Business Unit - Full Width -->
                      <div class="neo-input-wrapper">
                        <label>Business Unit <span class="required">*</span></label>
                        <input pInputText type="text" formControlName="businessUnit"
                          [readonly]="!userPrivileges.has('job_role.update')" placeholder="Enter business unit">
                      </div>

                      <!-- Openings and Maximum Applicants Grid -->
                      <div class="neo-grid neo-grid-cols-2">
                        <div class="neo-input-wrapper">
                          <label>Openings</label>
                          <input pInputText type="number" formControlName="openings"
                            [readonly]="!userPrivileges.has('job_role.update')" placeholder="0">
                        </div>
                        <div class="neo-input-wrapper">
                          <label>Maximum Applicants</label>
                          <input pInputText type="number" formControlName="maximumApplicants"
                            [readonly]="!userPrivileges.has('job_role.update')" placeholder="0">
                        </div>
                      </div>


                      <!-- Diversity Quotas Grid -->
                      <div class="neo-grid neo-grid-cols-3">
                        <div class="neo-input-wrapper">
                          <label>Diversity Male</label>
                          <input pInputText type="number" formControlName="diversityMale"
                            [readonly]="!userPrivileges.has('job_role.update')" placeholder="0">
                        </div>
                        <div class="neo-input-wrapper">
                          <label>Diversity Female</label>
                          <input pInputText type="number" formControlName="diversityFemale"
                            [readonly]="!userPrivileges.has('job_role.update')" placeholder="0">
                        </div>
                        <div class="neo-input-wrapper">
                          <label>Diversity Others</label>
                          <input pInputText type="number" formControlName="diversityOther"
                            [readonly]="!userPrivileges.has('job_role.update')" placeholder="0">
                        </div>
                      </div>

                    </div>
                  </div>



                </div>
              </div>

            </div>
          </div>

        </div>

      </div>

      <!-- Footer -->
      <div class="details-footer" *ngIf="roleData">
        <div class="footer-content-wrapper">
          <div class="footer-left">
            <span class="footer-label">Created By</span>
            <span class="footer-value">{{ roleData?.created_by?.first_name }} {{ roleData?.created_by?.last_name
              }}</span>
            <span class="footer-separator">|</span>
            <span class="footer-label">Created On</span>
            <span class="footer-value">{{ roleData?.created_at | date: 'dd.MM.yyyy HH:mm a' }}</span>
          </div>
        </div>
        <div class="footer-right" *ngIf="userPrivileges.has('job_role.update')">
          <button pButton type="button" label="Save Changes" class="save-changes-btn" [loading]="saveBtnLoading"
            [disabled]="!hasChanges || saveBtnLoading"
            (click)="saveChanges()">
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Empty State -->
<div class="empty-state" *ngIf="!loadingSpinner && !roleData">
  <i class="pi pi-exclamation-triangle"></i>
  <h3>Role not found</h3>
  <p>The requested role could not be found.</p>
  <button pButton label="Back to Roles" (click)="goBack()"></button>
</div>

<p-toast></p-toast>